import { useCookies } from "react-cookie";
import React, { useContext, useEffect, useState } from 'react';
import { TostMessageContext } from "../context/TostMessage";

export const useCart = () => {
  const [cookies, setCookie] = useCookies(["myCart"]);
  const { setTostMessage } = useContext(TostMessageContext);

  const addToCart = (name, product_id, type, quantity, selected, total_price, thumbnail) => {
    console.log(selected)
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const index = cart?.findIndex(
      item => item.product_id === product_id
    );

    let updatedCart;
    if (index !== -1) {
      cart[index] = {
        name,
        product_id,
        quantity,
        type,
        selected,
        total_price,
        thumbnail
      }
      updatedCart = cart;
      setTostMessage({
        messageType: 'success',
        message: 'Item replaced in Cart'
      })
    } else {
      updatedCart = [
        ...cart,
        { name, product_id, type, quantity, selected, total_price, thumbnail }
      ];
      setTostMessage({
        messageType: 'success',
        message: 'Item added to Cart'
      })
    }

    setCookie("myCart", updatedCart, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });
  };

  const removeItem = (product_id) => {
    // const cart = cookies.myCart || [];
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const index = cart?.findIndex(
      item => item.product_id === product_id
    );

    const updatedCart = cart;
    updatedCart.splice(index, 1);

    setCookie("myCart", updatedCart, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });

    setTostMessage({
      messageType: 'success',
      message: 'Item removed from Cart'
    })
  }

  const getCartTotal = () => {
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    return cart?.length;
  }

  const checkItemInCart = (product_id) => {
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const item = cart?.find(i => i.product_id === product_id)
    return item ? item.quantity : 0
  }

  function convertAmount(amount) {
    return 'NGN ' + Number(amount).toLocaleString("en-US")
    
    if (cookies?.user_country == "NG") {
      return 'NGN ' + Number(amount).toLocaleString("en-US")
    } else {
      return '$ ' + Number(amount).toLocaleString("en-US")
    }
  }

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return Number(value).toLocaleString("en-US");
    // return value.replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const parse = (v) =>
  v.replace(/,/g, '');

  function clearCart() {
    setCookie("myCart", [], {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });
  }

  return {
    cart: cookies.myCart || [],
    addToCart,
    getCartTotal,
    checkItemInCart,
    removeItem,
    convertAmount,
    formatAmount,
    parse,
    clearCart
  };
};
